import styled, { css } from 'styled-components';

import { pxToRem } from 'utils/scss';

export const ModalWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: 100vh;
`;

export const ModalGlobalContainer = styled.div`
  background-color: ${props => props.theme.colors.white};
  color: ${props => props.theme.colors.black.one};
  pointer-events: auto;
  position: relative;
  user-select: none;
  padding: 20px;
  border-radius: ${props =>
    props.type === 'editAccountData' ? pxToRem('20px') : pxToRem('15px')}
  padding: ${props =>
    props.type === 'editAccountData'
      ? `${pxToRem('48px')} ${pxToRem('138px')}`
      : `${pxToRem('40px')} ${pxToRem('32px')}`};
  box-shadow: ${props =>
    props.type === 'editAccountData'
      ? '0 42px 84px 0 rgba(197, 197, 197, 0.5)'
      : '1px 5px 8px 0 rgb(0 0 0 / 20%)'};
  height: ${({ height }) => (height ? `${height}` : 'auto')};
  max-height: ${pxToRem('744px')};
  width: ${({ width }) => (width ? pxToRem(width) : pxToRem('792px'))};
  ${props => {
    switch (props.type) {
      case 'accountDetailsModalCorporate':
        return css`
          min-width: ${pxToRem('792px')};
        `;
      case 'editAccountData':
        return css`
          min-width: ${pxToRem('791px')};
        `;
      default:
        return css`
          min-width: 'auto';
        `;
    }
  }}
  transition: all 250ms ease-in-out;
  position: relative;

  @media ${props => props.theme.device.tablet} {
    width: ${props => props.widthtablet && `${props.widthtablet}px`};
  }

  @media ${props => props.theme.device.mobile} {
    position: fixed;
    height: 100vh;
    width: 100vw;
    top: 0;
    left: 0;
    border-radius: 0;
    overflow: auto;

    display: flex;
    flex-direction: column;
  }
`;

export const ModalTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${pxToRem('12px')};
  color: ${props => props.theme.colors.black.one};
  position: relative;
  > span:first-of-type {
    margin: auto;
  }
`;

export const IconClose = styled.div`
  position: absolute;
  right: 0;
  top: ${pxToRem('-5px')};
`;
export const ModalDescription = styled.div`
  margin-bottom: ${pxToRem('20px')};
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: ${props => (props.singleButton ? 'flex-end' : 'center')};

  > button {
    margin-right: ${pxToRem('24px')};
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: ${pxToRem('30px')} ${pxToRem('10px')};
  position: relative;
`;

export const ModalBody = styled.div`
  width: 100%;
  margin-top: ${pxToRem('32px')};
  min-height: calc(100% - ${pxToRem('40px')});
  max-height: calc(100% - ${pxToRem('40px')});
  overflow: auto;

  @media ${props => props.theme.device.mobileL} {
    flex: 1 1 0;
  }
`;
